import React from 'react';
import headquarters from '../../assets/svgs/headquarters.svg';
import email from '../../assets/svgs/email.svg';
import ContactForm from '../../components/Contact/contactForm';

const ContactMain = () => {

    const contactInfo = [
        {
            image: headquarters,
            title: 'Headquarters',
            address: '#53 new road, stockyards, Melbourne 12233',
        },
        {
            image: email,
            title: 'Email',
            address: 'enquire@ranoxlogistics.com',
        },
        {
            image: email,
            title: 'Call',
            address: "(123) 456-7890",
        }
    ]



    return (
        <React.Fragment>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-3 '>
                            <div className='row'>
                                {contactInfo.map((item, index) => (
                                    <div className='col-lg-12 contact-info-item' key={index}>
                                        <div className='contact-info'>  
                                            <img src={item.image} alt={item.title} />
                                            <h3>{item.title}</h3>
                                            <address> {item.address} </address>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='col-lg-9 contact-form  px-5 '>
                            <h1 className='contact-form-title'>Contact Us</h1>
                            <p className='contact-form-description mb-5'>Shoot an email, our customer support executive will catch you shortly.</p>
                            <ContactForm />
                        </div>
                    </div>
                </div>


        </React.Fragment>
    );
}

export default ContactMain;
